import CategoryForm from "../../../../component/CategoryForm/CategoryForm";
import {useEffect, useState} from "react";
import Loading from "../../../../component/Loading/Loading";
import TextInput from "../../../../component/TextInput/TextInput";

const CurrencyForm = ({currency, onChange}) => {
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        (async () => {
            setIsLoading(false);
        })();

    }, []);


    if (isLoading)
        return <Loading/>

    return (
        <div className={"row"}>
            <div className="col-md-6">
                <TextInput label={"واحد پول"} value={currency.name} onChange={(value) => {
                    onChange({...currency , name: value})
                }}/>
            </div>
            <div className="col-md-6">
                <TextInput type={"number"} label={"نرخ"} value={currency.rate} onChange={(value) => {
                    onChange({...currency , rate: value})
                }}/>
            </div>
        </div>
    );
}

export default CurrencyForm;